var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePanel',{attrs:{"headline":"lang_PUBLISHING_TRACKING_PANEL_CAPTION_SETLISTS"},scopedSlots:_vm._u([{key:"panelContent",fn:function(){return [_c('BaseDataTableList',{attrs:{"headers":_vm.headers,"context":"Setlists","groupBy":"year","showExpand":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }